import * as React from 'react'
import { UploadedFileListConnected } from './UploadedFileListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TEAM_A_ID } from 'mockState'

export const UploadedFileListExamples = () => {
  return (
    <div className="UploadedFileListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UploadedFileListConnected teamId={MOCK_TEAM_A_ID} />
      </Provider>
    </div>
  )
}
